//-----------------------------------
// slideshow.js
// Implemnents Slick Slider for Sections
// https://github.com/kenwheeler/slick
//-----------------------------------

import $ from 'jquery'
import _assignIn from 'lodash/assignIn';
import 'slick-carousel'

 
// Local Variables
//-----------------------------------
let slideshows = {};

// Create New Slideshow Section 
//-----------------------------------
export let SlideshowSection = function(container) {
    let $container = this.$container = $(container),
        sectionId = $container.attr('data-section-id'),
        slideshow = this.slideshow = '#Slideshow-' + sectionId;

    slideshows[slideshow] = new Slideshow(slideshow);
};

SlideshowSection.prototype = _assignIn({}, SlideshowSection.prototype, {
  onUnload: function() {
    delete slideshows[this.slideshow];
  },

  onBlockSelect: function(evt) {
    let $slideshow = $(this.slideshow),
        $slide = $('.Slideshow-slide--' + evt.detail.blockId + ':not(.slick-cloned)'),
        slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function() {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});


// Slideshow Constructor
//-----------------------------------
const Slideshow = function(el) {

  this.$slideshow = null;

  let classes = {
    wrapper: 'js-Slideshow-wrapper',
    slideshow: 'js-Slideshow',
    currentSlide: 'slick-current'
  };

  this.$slideshow = $(el);
  this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);


  this.settings = {
    accessibility: true,
    arrows: false,
    appendDots: this.$slideshow.next('.js-Slideshow-dots'),
    dots: true,
    fade: this.$slideshow.data('transition'),
    draggable: true,
    touchThreshold: 20,
    autoplay: this.$slideshow.data('autoplay'),
    autoplaySpeed: this.$slideshow.data('speed'),
    mobileFirst: false
  };

  // if ($(window).width() > 767) {
  //   this.$slideshow.on('init', slideshowA11y.bind(this));
  //   this.$slideshow.slick(this.settings);
  // }
  this.$slideshow.on('init', slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        // if ((evt.which === 37) || (evt.which === 39)) {
        //   obj.$dots.find('.slick-active button').focus();
        // }
      });
    }
  }

  // // reslick only if it's not slick()
  // $(window).on('resize', function() {
  //   if ($(window).width() < 768) {
  //     if ($('.js-Slideshow').hasClass('slick-initialized')) {
  //       $('.js-Slideshow').slick('destroy');
  //     }
  //     return
  //   }

  //   if ($(window).width() > 767) {
  //     this.$slideshow.on('init', slideshowA11y.bind(this));
  //     this.$slideshow.slick(this.settings);
  //   }
  // });

};





















